import {v3} from 'oc-threejs/short3';
import BaseType from "./BaseType";
import Scenes from "oc-threejs/Scenes";
import InterieurDragBox from "./InterieurDragBox";
import Maths3 from "oc-threejs/Maths3";
import Helper from "../model/Helper";
import ArrangementRuler from './ArrangementRuler';

export default class AbstractInterieur extends BaseType(THREE.Group) {

    constructor(vsData) {
        super(vsData);
        this.hoverable = true;
        this.draggable = true;
        this.tapable = true;

        if(this.vsData?.disableInteraction) {
            this.draggable = false;
            this.tapable = false;
            this.hoverable = false;
        }

        this.createDragBox();

        // für lokales Koordinatensystem mit Ursprung links unten hinten
        // alle Objekte, die in compile erzeugt werden, sollten darin eingehängt werden
        this.boxLocalO3 = new THREE.Group();
        this.boxLocalO3.add(Debugs.point());
        this.add(this.boxLocalO3);
        this.ruler = new ArrangementRuler(vsData); //APP.model.object3d.ruler;

    }

    createDragBox() {
        this.dragBox = new InterieurDragBox();
        this.add(this.dragBox);
    }

    onChangeInDragSelectHoverState() {
        this.dragBox.show(this.hovering && !this.dragging);   
        STAGE.dirty();
    }

    vsUpdate() {
        // console.log(this.parent);
        this.position.copy(this.vsData.position);
        this.quaternion.copy(Maths3.quaternion.zero);
        if (this.isVsChanged('size')) {
            this.dragBox.setSize(this.vsData.size);
            this.boxLocalO3.position.copy(this.vsData.size).multiplyScalar(-0.5);
        }
    }

    onDrop() {
        // ohne das hier bleiben Interieurs beim Drop stehen, weil sie während des Drags auf dragging gesetzt sind und
        // dann expliziet nicht vom Model _removeUnusedCompilationObjects abgeräumt werden
        if (this.vsData.isOrphaned()) {
            Scenes.remove(this);
        }
    }

    onTap() {
        const interieurHoehe = this.vsData.size.y;
        const interieurPosition = this.vsData.position.y;
        const interieurFreuraumUnten = this.vsData.product.FreiraumUnten;
        const interieurLaengeY = this.vsData.frontSize ? this.vsData.frontSize.y : interieurHoehe;
        const interieurUnterkante = this.vsData.frontBox ? this.vsData.localToSchrank(this.vsData.frontBox.min).y : this.vsData.box.min.y;
        const interieurOberkante = this.vsData.frontBox ? this.vsData.localToSchrank(this.vsData.frontBox.max).y : this.vsData.box.max.y;
        APP.uiHandler.dialog({
            title: I18N('dialogPositionTitle', this.vsData.product.Name),
            text: I18N('dialogPositionText',
                Helper.formatToRulerUnit(interieurHoehe), // %1$s,
                Helper.formatToRulerUnit(interieurPosition), // %2$s,
                Helper.formatToRulerUnit(interieurFreuraumUnten), // %3$s,
                Helper.formatToRulerUnit(interieurLaengeY), // %4$s,
                Helper.formatToRulerUnit(interieurUnterkante), // %5$s,
                Helper.formatToRulerUnit(interieurOberkante), // %6$s,
            ),
            buttons: [
                {
                    style: 'primary',
                    label: I18N('OK'),
                    click: input => {
                    }
                }
            ]
        });
    }

    /**
     * gibt die Box eines Child im lokalen Koordinatensystem zurück
     * @param child
     * @returns {THREE.Box3}
     */
    localChildBox(child) {
        if (child.parent !== this.boxLocalO3) {
            throw "this.boxLocalO3 must be parent";
        }
        return Scenes.boundingBoxLocalMatrix(child);
    }

    onDragEnd() {
        this.vsData.dragDir = null;
        this.ruler.interieurDragRuler = [];
        this.ruler.vsUpdate(true);
    }

    onDrag() {
        setTimeout(function(){
            //do what you need here
        }, 100);
        
            this.vsData.position.y = this.position.y;
            APP.model.setDirty();
        
    }

}
